import { BaseDao } from './BaseDao';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { Action } from '../../models/action';

export class ActionDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.ACTION, apiHelper);
  }
}
